document.addEventListener("DOMContentLoaded", function () {
  var pdpItems = document.querySelectorAll(".pdp-question");
  var pdpAnswers = document.querySelectorAll(".pdp-answer");

  if (pdpItems.length > 0) {
    pdpItems[0].setAttribute("aria-expanded", "true");
    pdpAnswers[0].style.display = "block";
  }

  pdpItems.forEach(function (item, index) {
    item.addEventListener("click", function () {
      var answer = this.nextElementSibling;
      var isVisible = answer.style.display === "block";

      pdpAnswers.forEach(function (ans) {
        ans.style.display = "none";
      });

      pdpItems.forEach(function (pdp) {
        pdp.setAttribute("aria-expanded", "false");
      });

      if (!isVisible || index === 0) {
        answer.style.display = isVisible ? "none" : "block";
        this.setAttribute("aria-expanded", isVisible ? "false" : "true");
      }
    });
  });
});
